export enum LeaveTimeUnit {
Days,
Hours,
}
